export default __webpack_public_path__ + "static/media/prosecution_support_cells.635c1ead.jpg";